// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de la alfombra
 * @param {*} scene 
 */
export function cargaAssetsAlfombra(scene) {
  scene.load.image(
    "fondoAlfombra",
    ROUTES.rutaRuletaAlfombra + "/alfombraResized.png"
  );
}
